import { useState } from 'react';
import { Link } from 'react-router-dom';
import { timeAgo } from '@dashboard/shared/timeAgo';
import type { Order } from '@shared/types';

interface Props {
  orders: Order[];
}

export default function RecentRefunds({ orders }: Props) {
  const refunded = orders.filter((o) => o.status === 'refunded').slice(0, 5);
  if (refunded.length === 0) return null;

  return (
    <div
      className="rounded p-5"
      style={{
        border: '1px solid var(--dash-border)',
        background: 'var(--dash-card)',
      }}
    >
      <div
        className="font-mono text-[10px] uppercase tracking-widest mb-3"
        style={{ color: 'var(--dash-text-dim)' }}
      >
        Recent Refunds
      </div>
      <div className="space-y-2">
        {refunded.map((o) => (
          <RefundRow key={o.id} order={o} />
        ))}
      </div>
    </div>
  );
}

function RefundRow({ order }: { order: Order }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="flex items-center justify-between px-3 py-2 rounded"
      style={{
        border: '1px solid var(--dash-border-light)',
        background: 'var(--dash-input)',
      }}
    >
      <Link
        to={`/dashboard/stripe/orders/${order.id}`}
        className="font-mono text-xs transition-colors"
        style={{ color: hovered ? 'var(--dash-text-primary)' : 'var(--dash-text-tertiary)' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {order.id.slice(0, 8)}...
      </Link>
      <span className="font-mono text-xs text-red-400">
        -${order.expected_amount.toFixed(2)}
      </span>
      <span
        className="font-mono text-xs"
        style={{ color: 'var(--dash-text-dim)' }}
      >
        {timeAgo(order.created_at)}
      </span>
    </div>
  );
}
